const LOGO_URL = "https://customer-assets.emergentagent.com/job_bee-harvest-6/artifacts/5m5uevnv_Ricky%27s%20Bees%20Logo.png";
const ABN = "47 696 413 779";
const DEFAULT_BANK_DETAILS = "Account Name: Ricky's Bees\nAccount BSB: 083 004\nAccount Number: 365 643 471";

const formatAddress = (addr) => {
  if (!addr) return '';
  if (addr.pickup_location) return 'Pickup — ' + addr.pickup_location;
  return [
    addr.name || '',
    addr.street || '',
    addr.street2 || '',
    [addr.suburb, addr.state, addr.postcode].filter(Boolean).join(' ')
  ].filter(Boolean).join('<br>');
};

export const printInvoice = (order) => {
  const isPickup = order.shipping_method === 'pickup';
  const shippingAddr = formatAddress(order.shipping_address);
  const billingAddr = formatAddress(order.billing_address);
  const invoiceDate = new Date(order.created_at).toLocaleDateString('en-AU', {
    day: 'numeric', month: 'long', year: 'numeric'
  });

  const html = `
    <html>
    <head>
      <title>Invoice ${order.order_id} — Ricky's Bees</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: Georgia, 'Times New Roman', serif; color: #2D4B38; padding: 40px; max-width: 760px; margin: 0 auto; background: #fff; }
        .top-bar { height: 6px; background: #2D4B38; border-radius: 3px; margin-bottom: 32px; }
        .header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 36px; }
        .logo { height: 90px; width: auto; }
        .brand-details { font-family: Arial, sans-serif; font-size: 12px; color: #666; margin-top: 8px; line-height: 1.6; }
        .invoice-title { font-size: 38px; letter-spacing: 6px; font-weight: normal; text-align: right; color: #2D4B38; }
        .invoice-meta { font-family: Arial, sans-serif; font-size: 13px; text-align: right; margin-top: 12px; line-height: 1.8; color: #444; }
        .invoice-meta strong { color: #2D4B38; }
        .addresses { display: flex; gap: 24px; margin-bottom: 36px; }
        .address-box { flex: 1; background: #faf7f2; border-radius: 10px; padding: 18px 20px; }
        .address-label { font-family: Arial, sans-serif; font-size: 10px; text-transform: uppercase; letter-spacing: 1.5px; color: #a08c5b; margin-bottom: 8px; font-weight: bold; }
        .address-value { font-family: Arial, sans-serif; font-size: 13px; line-height: 1.7; color: #333; }
        .address-value .name { font-weight: bold; color: #2D4B38; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 8px; font-family: Arial, sans-serif; }
        th { text-align: left; padding: 12px 14px; background: #2D4B38; color: #fff; font-size: 11px; text-transform: uppercase; letter-spacing: 1px; }
        th:first-child { border-radius: 8px 0 0 8px; }
        th:last-child { border-radius: 0 8px 8px 0; }
        td { padding: 14px; border-bottom: 1px solid #eee5d5; font-size: 14px; color: #333; }
        .item-name { font-weight: 600; color: #2D4B38; }
        .totals { margin-top: 20px; margin-left: auto; width: 320px; font-family: Arial, sans-serif; }
        .total-row { display: flex; justify-content: space-between; padding: 6px 14px; font-size: 14px; color: #444; }
        .total-row.discount { color: #2e7d32; }
        .total-row.grand { font-size: 18px; font-weight: bold; color: #2D4B38; background: #faf7f2; border-radius: 8px; padding: 12px 14px; margin-top: 8px; }
        .payment { font-family: Arial, sans-serif; font-size: 13px; color: #444; margin-top: 28px; padding: 14px 18px; border: 1px solid #eee5d5; border-radius: 10px; display: inline-block; }
        .payment strong { color: #2D4B38; }
        .footer { margin-top: 48px; padding-top: 24px; border-top: 2px solid #2D4B38; text-align: center; }
        .thank-you { font-size: 18px; font-style: italic; color: #2D4B38; margin-bottom: 10px; }
        .footer-note { font-family: Arial, sans-serif; font-size: 11px; color: #999; line-height: 1.8; }
        @media print { body { padding: 20px; } }
      </style>
    </head>
    <body>
      <div class="top-bar"></div>
      <div class="header">
        <div>
          <img src="${LOGO_URL}" alt="Ricky's Bees" class="logo" />
          <div class="brand-details">
            Ricky's Bees<br>
            ABN ${ABN}<br>
            rickysbees.com.au
          </div>
        </div>
        <div>
          <div class="invoice-title">INVOICE</div>
          <div class="invoice-meta">
            <strong>Invoice No:</strong> ${order.order_id}<br>
            <strong>Date:</strong> ${invoiceDate}<br>
            <strong>Status:</strong> ${(order.status || 'confirmed').charAt(0).toUpperCase() + (order.status || 'confirmed').slice(1)}
          </div>
        </div>
      </div>

      <div class="addresses">
        <div class="address-box">
          <div class="address-label">Billed To</div>
          <div class="address-value">
            <span class="name">${order.customer_name || 'N/A'}</span><br>
            ${billingAddr ? billingAddr + '<br>' : ''}
            ${order.customer_email || ''}${order.customer_phone ? '<br>' + order.customer_phone : ''}
          </div>
        </div>
        ${shippingAddr ? `
        <div class="address-box">
          <div class="address-label">${isPickup ? 'Pickup' : 'Shipped To'}</div>
          <div class="address-value">${shippingAddr}</div>
        </div>` : ''}
      </div>

      <table>
        <thead>
          <tr><th>Item</th><th>Size</th><th style="text-align:center">Qty</th><th style="text-align:right">Unit Price</th><th style="text-align:right">Amount</th></tr>
        </thead>
        <tbody>
          ${order.items.map(i => `
            <tr>
              <td class="item-name">${i.name}</td>
              <td>${i.size}</td>
              <td style="text-align:center">${i.quantity}</td>
              <td style="text-align:right">$${i.price.toFixed(2)}</td>
              <td style="text-align:right">$${(i.price * i.quantity).toFixed(2)}</td>
            </tr>`).join('')}
        </tbody>
      </table>

      <div class="totals">
        <div class="total-row"><span>Subtotal</span><span>$${order.subtotal.toFixed(2)}</span></div>
        ${order.discount > 0 ? `<div class="total-row discount"><span>Discount${order.promo_code ? ' (' + order.promo_code + ')' : ''}</span><span>-$${order.discount.toFixed(2)}</span></div>` : ''}
        <div class="total-row"><span>Shipping</span><span>${order.shipping === 0 ? 'FREE' : '$' + order.shipping.toFixed(2)}</span></div>
        <div class="total-row grand"><span>Total (AUD)</span><span>$${order.total.toFixed(2)}</span></div>
      </div>

      <div class="payment">
        <strong>Payment Method:</strong> ${order.payment_display || (order.payment_method === 'stripe' ? 'Card (Stripe)' : 'PayPal')} &nbsp;·&nbsp; <strong>${order.payment_paid === false ? 'Payment Due' : 'Paid in Full'}</strong>
      </div>

      ${order.payment_paid === false ? `
      <div style="font-family: Arial, sans-serif; font-size: 13px; color: #444; margin-top: 16px; padding: 16px 18px; background: #faf7f2; border-radius: 10px; line-height: 1.8;">
        <div style="font-size: 10px; text-transform: uppercase; letter-spacing: 1.5px; color: #a08c5b; font-weight: bold; margin-bottom: 6px;">Payment Terms</div>
        ${order.payment_terms || 'Payment due within 14 days of invoice date.'}
        <br><br><strong style="color:#2D4B38">Pay by Direct Transfer:</strong><br>${DEFAULT_BANK_DETAILS.replace(/\n/g, '<br>')}
      </div>` : ''}

      <div class="footer">
        <div class="thank-you">Thank you for supporting Ricky's Bees</div>
        <div class="footer-note">
          Questions about your order? Contact us at sales@rickysbees.com.au
        </div>
      </div>
    </body>
    </html>
  `;

  const printWindow = window.open('', '_blank');
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.onload = () => printWindow.print();
};
